import React, { useEffect, useState, useTransition, forwardRef, useImperativeHandle, useRef } from 'react';
import { Badge, Box, IconButton, styled, Tooltip } from '@mui/material';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../../routes/routeName';
import { ELibraryFrontApi } from '../../../../api/e-library/e_library_front.api';
import { useTranslation } from 'react-i18next';

type Props = {
    cartCount?: number;
};

const IconButtonCustom = styled(IconButton)({
    backgroundColor: '#F2F4F7',
    borderRadius: '16px',
    color: '#292D32',
    width: '56px',
    height: '56px',
});

const BooksCart = forwardRef<HTMLButtonElement, Props>(({ cartCount = 0 }: Props, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isPending, startTransition] = useTransition();

    const [count_cart, set_count_cart] = useState<number>(cartCount);
    const innerBtnRef = useRef<HTMLButtonElement | null>(null);


    const handleGetListCart = async () => {
        await ELibraryFrontApi.cartCount()
            .then((res) => {
                if (res.status < 300) {
                    const response = res.data?.data || [];
                    set_count_cart(response || 0);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        handleGetListCart();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        set_count_cart((prev) => Math.max(prev, cartCount));
    }, [cartCount]);

    return (
        <Box className="flex flex-wrap gap-2 justify-end items-center">
            <Tooltip arrow title={t('รายการยืม/จอง')}>
                <IconButtonCustom
                    disabled={isPending}
                    onClick={() =>
                        startTransition(() => {
                            navigate(routeName.e_library.books_borrow);
                        })
                    }
                >
                    <LocalMallIcon sx={{ fontSize: '1.7rem' }} />
                </IconButtonCustom>
            </Tooltip>
            <Tooltip arrow title={t('ตะกร้าสินค้า')}>
                <Badge badgeContent={count_cart} color="error">
                    <IconButtonCustom
                        ref={innerBtnRef}
                        onClick={() =>
                            startTransition(() => {
                                navigate(routeName.e_library.books_shop_cart);
                            })
                        }
                        disabled={isPending}
                    >
                        <ShoppingCartIcon sx={{ fontSize: '1.7rem' }} />
                    </IconButtonCustom>
                </Badge>
            </Tooltip>
        </Box>
    );
});

BooksCart.displayName = 'BooksCart';
export default BooksCart;
